// components/DemoForm.js
import React, { useState } from "react";
import "../../src/App.css";

function DemoForm({ onClose }) {
  const [formData, setFormData] = useState({
    email: "",
    subject: "",
    company: "",
    description: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "/api/request_demo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData.email,
            subject: formData.subject,
            company: formData.company,
            description: formData.description,
          }),
        }
      );

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({
          email: "",
          subject: "",
          company: "",
          description: "",
        });

        // ✅ Auto-close after 1.5 seconds
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="demo-form-overlay">
      <div className="demo-form-container">
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <h2>Richiedi una Demo</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Oggetto</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="company">Azienda</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Descrizione</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Invio in corso..." : "Invia Richiesta"}
          </button>
          {submitStatus === "success" && (
            <div className="success-message">
              Richiesta inviata con successo!
            </div>
          )}
          {submitStatus === "error" && (
            <div className="error-message">
              Invio richiesta fallito. Riprova per favore.
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default DemoForm;
